// apiService.ts
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "./axios";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const getHolidays = async (userId) => {
  console.log(userId, 'fetchDataById')
  const response = await axiosInstance.get(
    `/appointments/holidays/${userId}`
  );
  return response.data;
};

const saveHoliday = async (data) => {
  const response = await axiosInstance.post(`/appointments/set-holidays`, data);
  return response.data;
};

const deleteHoliday = async (id) => {
  console.log(id, 'holidayId')
  const response = await axiosInstance.delete(
    `/appointments/holidays/${id}`
  );
  return response.data;
};

const useHolidays = ({ userId = null } = {}) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  if (!userId) {
    const users = useSelector((state) => state?.userData?.userData?.user);
    console.log(users?._id, 'useAvailability')
    userId = users?._id;
  }
  const [holidays, setHolidays] = useState([])
  const { data: holidaysData = [] } = useQuery({
    queryKey: ["holidays"],
    queryFn: () => getHolidays(userId),
    enabled: !!userId,
  });
  useEffect(() => {
    console.log(holidaysData, 'holidaysData fetch')
    if (holidaysData.holidays?.length > 0) {
      console.log('fetched holiday data', holidaysData)
      setHolidays([...holidaysData?.holidays]);
    }
  }, [holidaysData]);
  const saveHolidaysMutation = useMutation({
    mutationFn: saveHoliday,
    onSuccess: (data) => {
      toast.success(data.message)
    },
    onError: (error) => {
      toast.error(error.message,)
      setHolidays([...holidaysData?.holidays]);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['holidays'],
        exact: true,
      })
    },
  });
  const deleteHolidaysMutation = useMutation({
    mutationFn: deleteHoliday,
    onSuccess: (data) => {
      toast.success(data.message)
    },
    onError: (error) => {
      console.log(error.message, 'jhbrjhvbr')
      setHolidays([...holidaysData?.holidays]);
      toast.error(error.message)
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['holidays'],
        exact: true,
      })
    },
  });
  return {
    holidays,
    saveHolidaysMutation,
    deleteHolidaysMutation
  };
};
export default useHolidays;
